import { flow } from 'lodash';

import { NAME } from './clients.constant';

const selectStateKey = (state) => state[NAME];
const selectLoadingKey = (state) => state.loading;
const selectPayloadKey = (state) => state.payload;

export const selectState = flow(selectStateKey);
export const selectLoading = flow(selectState, selectLoadingKey);
export const selectPayload = flow(selectState, selectPayloadKey);
